import { render, staticRenderFns } from "./UsersGroupsAdd.vue?vue&type=template&id=5c9ffc78&"
import script from "./UsersGroupsAdd.vue?vue&type=script&lang=js&"
export * from "./UsersGroupsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports